import type { RichTextLinksType } from '@/models/contentful/richText-models'

interface RichTextItems {
  assets: Map<unknown, unknown>
  entries: Map<unknown, unknown>
}

export const getRichTextItemsMap = (links: RichTextLinksType): RichTextItems => {
  const items: RichTextItems = {
    assets: new Map(),
    entries: new Map(),
  }

  // loop through the assets and add them to the map
  links?.assets?.block?.forEach((asset) => {
    items.assets.set(asset.sys.id, asset)
  })
  links?.assets?.hyperlink?.forEach((asset) => {
    items.assets.set(asset.sys.id, asset)
  })

  // loop through the block linked entries and add them to the map
  links?.entries?.block?.forEach((entry) => {
    items.entries.set(entry.sys.id, entry)
  })

  // loop through the inline linked entries and add them to the map
  links?.entries?.inline?.forEach((entry) => {
    items.entries.set(entry.sys.id, entry)
  })

  links?.entries?.hyperlink?.forEach((entry) => {
    items.entries.set(entry.sys.id, entry)
  })

  return items
}
